let inMemoryAccessToken: string | null = null;
let inMemoryIdToken: string | null = null;

export const setAccessToken = (token: string | null) => {
  inMemoryAccessToken = token;
};
export const setIdToken = (token: string | null) => {
  inMemoryIdToken = token;
};

export const getAccessToken = () => {
  return inMemoryAccessToken;
};
export const getIdToken = () => {
  return inMemoryIdToken;
};
